import { ApplicationController } from "../../application_controller"
import SelectizePublicController from "../../layouts/helpers/selectize_public_controller"
import DaterangepickerPublicController from "../../layouts/helpers/daterangepicker_public_controller"

export default class extends ApplicationController {
    initialize() {}

    connect() {
	var selectize_public_controller = new SelectizePublicController()
	selectize_public_controller.create(this.element)
	var daterangepicker_public_controller = new DaterangepickerPublicController()
	daterangepicker_public_controller.create(this.element)

	this.element.querySelectorAll("form textarea").forEach(el => { this.textareaResize(el) })
    }

    disconnect() {
	var selectize_public_controller = new SelectizePublicController()
	selectize_public_controller.destroy(this.element)
    }

    textareaResizer(event) {
	this.textareaResize(event.currentTarget)
    }

    textareaResize(element) {
	element.style.height = "auto"
	element.style.height = (element.scrollHeight + 2) + "px"
    }
}
